import styled, { css } from 'styled-components';

import { ChatAreaContainer } from '../../styled-components/ChatAreaContainer';

export const MessageInputBoxWrapper = styled(ChatAreaContainer) <{
  $resetError?: boolean;
  $background?: string;
  $noBorder?: boolean;
}>`
  display: flex;
  flex-direction: column;
  ${({ $background }) => $background && `background: ${$background};`}

  ${({ $resetError, theme }) =>
    $resetError &&
    css`
      // animate to red and back to initial
      .message-input-btn.reset svg {
        color: ${theme.color.errorIcon};
        transition: color 0.5s;
    `};
`;

export const MessageInputBoxButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  svg {
    color: ${({ theme }) => theme.color.messageInputButton};
  }
  
  .placeholder {
    line-height: 1;
    display: inline-flex;
    align-items: center;
    vertical-align: top;
  }
`;

export const MessageInputBoxTextAreaWrapper = styled.div<{
  $minHeight?: string;
}>`
  display: flex;
  align-items: stretch;
  textarea {
    background: transparent;
    padding: 8px;
    border: none;
    width: 100%;
    min-height: 100%;
    resize: none;
    font-size: ${({ theme }) => theme.font.size.default};
    color: ${({ theme }) => theme.color.messageInputButton};
    caret-color: ${({ theme }) => theme.color.messageInputButton};

    &:focus-visible {
      outline: none;
    }
  }
  min-height: ${({ $minHeight }) => $minHeight || '8rem'};

  textarea::placeholder {
    color: ${({ theme }) => theme.color.messageInputButton};
  }
`;
